import React from 'react';
import SectionHeader from './ui/SectionHeader';

export default function AboutStory() {
  return (
    <section className="py-32 bg-stone-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <div className="relative">
            <div className="aspect-[4/5] rounded-3xl overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=1000&auto=format&fit=crop" 
                alt="Forest sustainable source" 
                className="w-full h-full object-cover opacity-80"
              />
            </div>
            <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-teal-800/20 backdrop-blur-3xl rounded-full -z-10"></div>
          </div>
          
          <div>
            <SectionHeader title="Design for the Next Decade" subtitle="Our Philosophy" centered={false} dark={true} />
            <div className="space-y-6 text-stone-400 leading-relaxed">
              <p>
                At TerraSip, we believe the most sustainable product is the one you already own. We don't design for seasonal trends; we design for durability, utility, and circularity.
              </p>
              <p>
                Our journey started in a small workshop in Portland with a simple goal: create a bottle that never needs to reach a landfill. Every component—from the silicone bumper to the steel body—is replaceable, repairable, and ultimately, recyclable.
              </p>
              <div className="grid grid-cols-2 gap-8 pt-8">
                <div>
                  <h4 className="text-white font-bold text-lg mb-2">100% Carbon Neutral</h4>
                  <p className="text-sm">Offsetting every shipment through certified forest restoration projects.</p>
                </div>
                <div>
                  <h4 className="text-white font-bold text-lg mb-2">Ethical Sourcing</h4>
                  <p className="text-sm">Rigorous auditing of our supply chain to ensure fair wages and safe conditions.</p>
                </div>
              </div>
              <div className="pt-10">
                <button className="bg-white text-stone-900 px-8 py-4 rounded-full font-bold hover:bg-teal-400 transition-colors">
                  Read Our 2024 Impact Report
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}